// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"58":"3787cab9","60":"b0d05162","146":"0da62379","362":"34ba3109","453":"a074a449","594":"349f39a6","694":"ed691c8d","698":"ecf832f7","807":"ce6b64b2"}[chunkId] + ".chunk.js";
};